import { connect } from 'react-redux';
import Monitoring from './components/Monitoring';
import { loadUser, loadMySubscriptionPlan } from '../../redux/actions/user';

import {
  loadMonitoringQueries,
  deleteMonitoringQuery,
  changeScopeMonitoringQuery,
  runMonitoringQuery,
  loadMonitoringQueryResultsHistory,
  updateMonitoringQuery,
  loadMonitoringFile,
} from '../../redux/actions/ioc';
import { fileDownload, fileContentCopy } from '../../redux/actions/download';

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    monitoringQueries: state.ioc.monitoringQueries,
    monitoringQueriesCount: state.ioc.monitoringQueriesCount,
    monitoringQueryResultHistories: state.ioc.monitoringQueryResultHistories,
    monitoringQueryResultHistoryStatus:
      state.ioc.monitoringQueryResultHistoryStatus,
    monitoringQueriesStatus: state.ioc.monitoringQueriesStatus,
    copyFileContentStatus: state.download.copyFileContentStatus,
    downloadFileStatus: state.download.downloadFileStatus,
    updateMonitorStatus: state.ioc.updateMonitorStatus,
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  };
};

const mapDispatchToProps = {
  loadUser,
  loadMonitoringQueries,
  deleteMonitoringQuery,
  changeScopeMonitoringQuery,
  runMonitoringQuery,
  loadMonitoringQueryResultsHistory,
  updateMonitoringQuery,
  loadMonitoringFile,
  fileDownload,
  fileContentCopy,
  loadMySubscriptionPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(Monitoring);
